import { Form, Input, Modal, Select, Table, Tag } from "antd";
import { get } from "lodash";
import { useState } from "react";
import { BiPlus } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import Header from "shared/components/Header";
import { useMutation, useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import cuid from "cuid";

const CATEGORY_OPTIONS = [
  { value: "cold_outreach", label: "Prospection à froid" },
  { value: "re_engagement", label: "Ré-engagement" },
  { value: "event_followup", label: "Suivi événement" },
  { value: "inbound_nurture", label: "Nurture entrant" },
  { value: "upsell", label: "Upsell" },
  { value: "custom", label: "Personnalisé" },
];

const CATEGORY_LABELS = Object.fromEntries(CATEGORY_OPTIONS.map((c) => [c.value, c.label]));

const List = () => {
  const navigate = useNavigate();
  const { data, refetch } = useQuery(graphql.queries.CRM_SEQUENCE_TEMPLATES, { variables: {}, fetchPolicy: "network-only" });
  const [createTemplate] = useMutation(graphql.mutations.CREATE_CRM_SEQUENCE_TEMPLATE);
  const [createSequence] = useMutation(graphql.mutations.CREATE_CRM_SEQUENCE);
  const [createOpen, setCreateOpen] = useState(false);
  const [form] = Form.useForm();
  const templates = get(data, "crmSequenceTemplates.data") || [];

  const handleCreate = async () => {
    const values = await form.validateFields();
    const templateId = cuid();
    const sequenceId = cuid();

    try {
      await createSequence({ variables: { data: { id: sequenceId } } });
      await createTemplate({
        variables: {
          data: {
            id: templateId,
            name: values.name,
            description: values.description || null,
            category: values.category || "custom",
            channelMix: [],
            stepCount: 0,
            estimatedDurationDays: 0,
            sequenceId,
            usageCount: 0,
          },
        },
      });
      form.resetFields();
      setCreateOpen(false);
      await refetch();
      navigate(`${SCREENS.PRIVATE.ADMIN.SEQUENCE_TEMPLATES.DETAIL.path}/${templateId}`);
    } catch (err) { /* handled by hook */ }
  };

  return (
    <>
      <Header key="header" title="Modèles de séquences" actions={[{ text: "Nouveau modèle", onClick: () => setCreateOpen(true), type: "primary", icon: <BiPlus size={18} /> }]} />
      <Table dataSource={templates} rowKey="id" size="small"
        onRow={(record) => ({
          onClick: () => navigate(`${SCREENS.PRIVATE.ADMIN.SEQUENCE_TEMPLATES.DETAIL.path}/${record.id}`),
          style: { cursor: "pointer" },
        })}
        columns={[
        { title: "Nom", dataIndex: "name", render: (name) => <strong>{name}</strong> },
        { title: "Catégorie", dataIndex: "category", width: 150, render: (cat) => <Tag>{CATEGORY_LABELS[cat] || cat || "—"}</Tag> },
        { title: "Étapes", dataIndex: "stepCount", width: 80 },
        { title: "Durée", dataIndex: "estimatedDurationDays", width: 80, render: (d) => d ? `${d} j` : "—" },
        { title: "Utilisations", dataIndex: "usageCount", width: 100 },
      ]} />

      <Modal title="Nouveau modèle" open={createOpen} onCancel={() => setCreateOpen(false)} onOk={handleCreate} okText="Créer" cancelText="Annuler">
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Nom" rules={[{ required: true, message: "Le nom est requis" }]}>
            <Input placeholder="Ex: Cold Email Standard" />
          </Form.Item>
          <Form.Item name="description" label="Description">
            <Input.TextArea rows={2} placeholder="Description du modèle" />
          </Form.Item>
          <Form.Item name="category" label="Catégorie" initialValue="custom">
            <Select>
              {CATEGORY_OPTIONS.map((c) => <Select.Option key={c.value} value={c.value}>{c.label}</Select.Option>)}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default List;
